import React from "react";
import { Button } from "@components/ui/button";
import { Card } from "@components/ui/card";
import { Share2 } from "lucide-react";
import { requestTransferSuperoneApiData } from "@helpers/requestTransferSuperoneApiData";

const ApiData: React.FC = () => {
  const [apiData, setApiData] = React.useState<any>(null);
  const [apiLoading, setApiLoading] = React.useState(false);
  const [apiError, setApiError] = React.useState("");

  const handleApiData = async () => {
    setApiLoading(true);
    setApiError("");
    setApiData(null);
    try {
      const data = await requestTransferSuperoneApiData();
      setApiData(data);
    } catch (err) {
      setApiError(err instanceof Error ? err.message : String(err));
    } finally {
      setApiLoading(false);
    }
  };

  return (
    <Card className="hover:shadow-lg transition-shadow duration-200 overflow-hidden p-6 border border-gray-800 w-full">
      <h2 className="text-lg font-semibold font-heading mb-4 flex items-center text-superone-charcoal">
        <Share2 className="mr-2 h-5 w-5 text-pink-500" />
        API Data
      </h2>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col items-start">
          <span className="text-yellow-700 bg-yellow-100 rounded px-2 py-1 font-medium mb-4">
            Do not use this section unless you understand the implications of
            transferring SuperOne API data.
          </span>
          <Button
            type="button"
            onClick={handleApiData}
            disabled={apiLoading}
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 disabled:opacity-50 cursor-pointer font-normal"
          >
            {apiLoading
              ? "Loading Latest SuperOne API Data"
              : "Get Latest SuperOne API Data"}
          </Button>
        </div>
        {apiError && (
          <div className="text-red-500 mt-2">API Error: {apiError}</div>
        )}
        {apiData && (
          <div
            className="mt-4 p-4 bg-green-50 border border-green-200 rounded text-green-900 overflow-auto"
            style={{ maxHeight: 300 }}
          >
            <strong>Transfer SuperOne API Data:</strong>
            <pre style={{ fontSize: 12 }}>
              {JSON.stringify(apiData, null, 2)}
            </pre>
          </div>
        )}
      </div>
    </Card>
  );
};

export default ApiData;
